import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withTranslation } from 'react-i18next'
import Moment from 'moment'

import employeeService from '../../../../services/Employee.service'
import { UserRoles } from '../../../../constants'
import { addFlashMessageOfType } from 'redux-flash-messages'
import { actions as employeeActions } from '../../../../actions/employee'
import { formatPercentage } from "../../../../utils/jsUtils"

import { FEDERAL_TAX_RATES_TYPE, setLocationOfPriorFocus } from '../common'
import { LoadingButton } from '../LoadingButton'
import { AWARD_VIEW_BY_OPTIONS } from '../../stockAwards/common'
import StencilLinkStyling from '../StencilLinkStyling'
import { GenericDetailTitle } from "./GenericDetailTitle"

import { InputWrapper } from '@amzn/stencil-react-components/form'
import { Flyout, FlyoutContent } from '@amzn/stencil-react-components/flyout'
import { WithBreakpoints } from '@amzn/stencil-react-components/responsive'
import { Label, Text } from '@amzn/stencil-react-components/text'
import { Select } from '@amzn/stencil-react-components/form'
import { Col, Hr, Row, Spacer, Flex } from '@amzn/stencil-react-components/layout'
import { Button, ButtonVariant } from '@amzn/stencil-react-components/button'
import { IconArrowRight, IconChevronDown } from '@amzn/stencil-react-components/icons'
import { Link } from '@amzn/stencil-react-components/link'

export class ChangeTaxRateDialog extends Component {

  constructor(props) {
    super(props);
    this.newTaxRateInputRef = React.createRef();
    this.state = this.defaultState(props);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.visible !== this.props.visible) {
      this.setState(this.defaultState(this.props));
    }
  }

  createPreclearanceText = (t, employee) => {
    if (employeeService.isAPSEmployee(employee)) {
      return (
        <>
          <StencilLinkStyling>
            <Text dataTestId="PreclearanceText_title"
                  dangerouslySetInnerHTML = {{ __html: t('USFedRateDialog.PreclearanceToolText') }}/>
          </StencilLinkStyling>
          <Link
            dataTestId="PreclearanceText_link"
            href={process.env.REACT_APP_PRECLEAR}
            target="_blank"
          >
            {t('USFedRateDialog.PreclearanceToolLink')}
          </Link>
        </>
      )
    } else {
      return (
        <StencilLinkStyling>
          <Text dataTestId="PreclearanceText_PreclearanceWholeFoodsText"
                dangerouslySetInnerHTML = {{ __html: t('USFedRateDialog.PreclearanceWholeFoodsText') }}/>
        </StencilLinkStyling>
      )
    }
  }

  formatAwardIdToAwardSelectObj = (awardId) => {
    var defaultAward = null;
    this.props.unvestedAwards.forEach((award) => {
      if (award.id === awardId) {
        defaultAward = {value: award.id, label: `${award.amazon_award_name} | ${award.amazon_award_id}`}
      }
    });
    return defaultAward;
  }

  formatYearToYearSelectObj = (year) => {
    return {value: year, label: year};
  }

  defaultState = (props) => {
    let defaultAdditionFiltersVisible;
    let defaultFederalTaxRateType;
    let defaultSecondFilter;

    if(props.viewType === AWARD_VIEW_BY_OPTIONS.AWARD_DATE) {
      if (props.awardIdSelected === null) { // Default selection.
        defaultAdditionFiltersVisible = false;
        defaultFederalTaxRateType = FEDERAL_TAX_RATES_TYPE.AllAwards;
        defaultSecondFilter = Object.keys(props.vestsByYear)[0];
      } else { // Award selection.
        defaultSecondFilter = this.formatAwardIdToAwardSelectObj(props.awardIdSelected);
        defaultAdditionFiltersVisible = true;
        defaultFederalTaxRateType = FEDERAL_TAX_RATES_TYPE.ByVest;
      }
    } else if(props.viewType === AWARD_VIEW_BY_OPTIONS.CALENDAR_YEAR) {
      defaultAdditionFiltersVisible = true;
      defaultFederalTaxRateType = FEDERAL_TAX_RATES_TYPE.ByYear;
      defaultSecondFilter = props.calendarYear === null ? this.formatYearToYearSelectObj(Object.keys(props.vestsByYear).slice(-1)) : this.formatYearToYearSelectObj(props.calendarYear);
    } else {
      defaultAdditionFiltersVisible = false;
      defaultFederalTaxRateType = FEDERAL_TAX_RATES_TYPE.AllAwards;
      defaultSecondFilter = Object.keys(props.vestsByYear)[0];
    }

    return {
      additionFiltersVisible: defaultAdditionFiltersVisible,
      federalTaxRateTypeSelected: defaultFederalTaxRateType,
      secondFilterSelected: defaultSecondFilter,
      newTaxRateSelected: null,
      vestEventsArray: [],
      newTaxRateReminderVisible: false,
      loading: false
    };
  }

  setLoadingState = (value) => {
    this.setState({
      loading: value
    })
  }

  //Returns list of vest ids
  getVestIdsFromVestEvents = () => {
    const vestList = [];
    this.state.vestEventsArray.map(vest => {
      vestList.push(vest.value)
    });
    return vestList;
  }

  //Returns list of vest objects
  getVestObjectListFromVestEvents = () => {
    const vestList = [];
    this.state.vestEventsArray.map(info => {
      vestList.push(info.vest)
    });
    return vestList;
  }

  taxRateAppliedHandler = () => {
    // if the new tax is not selected, remind of the tax rate input and stop running handler
    if (!this.state.newTaxRateSelected) {
      this.setState({
        newTaxRateReminderVisible: true
      });
      this.newTaxRateInputRef.current?.focus();
      return;
    }

    this.setLoadingState(true);

    let applyToFutureVests = this.state.federalTaxRateTypeSelected === FEDERAL_TAX_RATES_TYPE.AllAwards;
    let vests = [];
    let taxRate = this.state.newTaxRateSelected;

    if (this.state.federalTaxRateTypeSelected === FEDERAL_TAX_RATES_TYPE.AllAwards || this.state.federalTaxRateTypeSelected === FEDERAL_TAX_RATES_TYPE.CurrentAwards) {
      this.props.unvestedAwards.forEach((award) => {
        award.vests.forEach((vest) => {
          if (!vest.vested)
            vests.push(vest.id)
        })
      });
    } else if (this.state.federalTaxRateTypeSelected === FEDERAL_TAX_RATES_TYPE.ByYear) {
      if (this.state.vestEventsArray.length === 0) {
        let vestsByYear = this.props.vestsByYear[this.state.secondFilterSelected.value];
        vests = vestsByYear.remaining.map((vest) => {
          return vest.id
        });
      } else {
        vests = this.getVestIdsFromVestEvents();
      }
    } else if (this.state.federalTaxRateTypeSelected === FEDERAL_TAX_RATES_TYPE.ByVest) {
      if (this.state.vestEventsArray.length === 0) {
        let award = employeeService.loadAward(this.props.unvestedAwards, this.state.secondFilterSelected.value);
        if (award && award.vests) {
          vests = award.vests.filter((vest) => !vest.vested )
          .map((vest) => {
            return vest.id
          });
        }
      } else {
        vests = this.getVestIdsFromVestEvents();
      }
    }

    const priorFocus = setLocationOfPriorFocus(this.props.refFrom, this.props.idFrom);

    // Do nothing if it doesn't have vests.
    if (vests.length === 0 || this.state.federalTaxRateTypeSelected === null) {
      this.setLoadingState(false);
      this.props.onCloseDialog();
      addFlashMessageOfType("SUCCESS", false, this.props.t('ChangeTaxRateDialog.USFederalTaxRateApplied'), null, priorFocus);
      return
    }
    this.props.actions.employee.applyTaxRate([], vests, taxRate, applyToFutureVests).then( _ => {
      this.setLoadingState(false);
      this.props.onCloseDialog();
      addFlashMessageOfType("SUCCESS", false, this.props.t('ChangeTaxRateDialog.USFederalTaxRateApplied'), null, priorFocus);
    }).catch( _ => {
      this.setLoadingState(false);
      this.props.onCloseDialog();
      addFlashMessageOfType("ERROR", false, this.props.t('ChangeTaxRateDialog.FailedToApplyFederalTax'), null, priorFocus);
    })
  }

  getFederalTaxRateTypeOptions = (t) => {
    var options = [];
    Object.values(FEDERAL_TAX_RATES_TYPE).forEach((value) => {
      return options.push({value: value, label: t(`FederalTaxRateType.${value}`)})
    });
    return options;
  }

  getTaxRatesOptions = (t) => {
    let options = this.props.configuration.tax_rates.map(taxRate => (
      {value: taxRate, label: `${formatPercentage(this.props.locale, taxRate)}`})
    );

    return options;
  }

  getSecondFilterOptions = () => {
    var options = [];

    if (this.state.federalTaxRateTypeSelected === FEDERAL_TAX_RATES_TYPE.ByYear) {
      Object.keys(this.props.vestsByYear).forEach((key)=>{
        if(this.props.vestsByYear[key].remaining.length > 0) {
          options.push({value: key, label: key})
        }
      });
    } else if (this.state.federalTaxRateTypeSelected === FEDERAL_TAX_RATES_TYPE.ByVest) {
      this.props.unvestedAwards.map((award) => {
        return options.push({value: award.id, label: `${award.amazon_award_name} | ${award.amazon_award_id}`})
      });
    }

    return options;
  }

  getVestEventOptions = () => {
    var options = [];
    if(this.state.federalTaxRateTypeSelected === FEDERAL_TAX_RATES_TYPE.ByYear) {
      const vests = this.props.vestsByYear[this.state.secondFilterSelected.value];

      vests && vests.remaining.map((vest, index) => {
        const award = employeeService.loadAward(this.props.awards, vest.award_id)
        return options.push({value: vest.id.toString(), label: `${award.amazon_award_name} | ${award.amazon_award_id}`, award: award, vest: vest})
      });
    } else if(this.state.federalTaxRateTypeSelected === FEDERAL_TAX_RATES_TYPE.ByVest) {
      const award = employeeService.loadAward(this.props.unvestedAwards, this.state.secondFilterSelected.value);
      if (award) {
        award.vests && award.vests.filter((vest) => !vest.vested )
        .map((vest, index) => {
          return options.push({value: vest.id.toString(), label: `${award.amazon_award_name} | ${award.amazon_award_id}`, award: award, vest: vest})
        });
      }
    }

    return options;
  }

  onFederalTaxTypeChange = (selectedTaxType) => {
    let additionFiltersVisible = (selectedTaxType.value === FEDERAL_TAX_RATES_TYPE.ByYear || selectedTaxType.value === FEDERAL_TAX_RATES_TYPE.ByVest);

    this.setState({
      additionFiltersVisible: additionFiltersVisible,
      federalTaxRateTypeSelected: selectedTaxType.value,
      secondFilterSelected: selectedTaxType.value === FEDERAL_TAX_RATES_TYPE.ByYear ? this.formatYearToYearSelectObj(Object.keys(this.props.vestsByYear).slice(-1)) : this.formatAwardIdToAwardSelectObj(this.props.unvestedAwards[0].id)
    });
  }

  onSecondFilterChange = (selectedOption) => {
    this.setState({
      secondFilterSelected: selectedOption
    });
  }

  onNewTaxRateChange = (taxRate) => {
    this.setState({
      newTaxRateSelected: taxRate.value,
      newTaxRateReminderVisible: false
    });
  }

  formatFederalTaxRateTypeSelected = (t) => {
    return {value: this.state.federalTaxRateTypeSelected, label: t(`FederalTaxRateType.${this.state.federalTaxRateTypeSelected}`)}
  }

  getTaxRatesRange = () => {
    const { federalTaxRateTypeSelected, secondFilterSelected } = this.state;
    const { default_tax_rate } = this.props.configuration;
    let list = [];

    if (federalTaxRateTypeSelected === FEDERAL_TAX_RATES_TYPE.CurrentAwards) {
      this.props.unvestedAwards.forEach(award => {
        award.vests.forEach(vest =>{
            list = list.concat(vest)
        })
      });
    } else if (federalTaxRateTypeSelected === FEDERAL_TAX_RATES_TYPE.ByYear) {
      if (this.state.vestEventsArray.length === 0) {
        if(Object.keys(this.props.vestsByYear).length <= 0) {
          return default_tax_rate;
        } else {
          const vestsByYear = this.props.vestsByYear[secondFilterSelected.value];
          list = vestsByYear.remaining;
        }
      } else {
        list = this.getVestObjectListFromVestEvents();
      }
    } else if (federalTaxRateTypeSelected === FEDERAL_TAX_RATES_TYPE.ByVest) {
      if (this.state.vestEventsArray.length === 0) {
        const award = employeeService.loadAward(this.props.unvestedAwards, secondFilterSelected.value);
        if (award && award.vests) {
          list = award.vests.filter(vest => !vest.vested);
        }
      } else {
        list = this.getVestObjectListFromVestEvents();
      }
    } else { // AllWards
      this.props.awards.forEach(award => {
        award.vests.forEach(vest =>{
          list = list.concat(vest)
        })
      });
    }

    let taxRatesRange = employeeService.getTaxRatesRange(list, default_tax_rate);
    return taxRatesRange.map(tr => formatPercentage(this.props.locale, tr)).join(' - ');
  }

  onSelectVestEvent = (selectedOptions) => {
    const selectedEventList = [];
    selectedOptions.map(vestInfo => {
      selectedEventList.push(vestInfo);
    });

    this.setState({
      vestEventsArray: selectedEventList
    });
  }

  getAwardSelectComponents = (t, disabled) => {
    if (disabled) {
      return null;
    }
    const taxTypesSelectId = "federal-tax-types";
    const taxTypesLabelId = "federal-tax-types-label";

    return (
      <>
        <Label dataTestId="AwardSelectComponents_label" htmlFor={taxTypesSelectId} id={taxTypesLabelId}>
          <GenericDetailTitle title={t('ChangeTaxRateDialog.ChangeUSFederalTaxRate')}/>
        </Label>
        <Select
          dataTestId="AwardSelectComponents_taxTypes_selection"
          labelId={taxTypesLabelId}
          id={taxTypesSelectId}
          options={this.getFederalTaxRateTypeOptions(t)}
          renderOption={this.renderOptionLabel}
          renderNativeOption={this.renderOptionLabel}
          renderSelectedValue={this.renderOptionLabel}
          valueAccessor={this.renderOptionLabel}
          onChange={this.onFederalTaxTypeChange}
          defaultValue={this.formatFederalTaxRateTypeSelected(t)}
          value={this.formatFederalTaxRateTypeSelected(t)}
        />
        {this.state.additionFiltersVisible &&
          <>
            <Select
              dataTestId="AwardSelectComponents_second_filter_selection"
              id="second-filter"
              options={this.getSecondFilterOptions()}
              renderOption={this.renderOptionLabel}
              renderNativeOption={this.renderOptionLabel}
              renderSelectedValue={this.renderOptionLabel}
              valueAccessor={this.renderOptionLabel}
              onChange={this.onSecondFilterChange}
              defaultValue={this.state.secondFilterSelected}
              value={this.state.secondFilterSelected}
            />
            <Select
              dataTestId="AwardSelectComponents_vest_event_selection"
              id="vest-event"
              options={this.getVestEventOptions()}
              renderOption={this.renderMultiOption}
              renderNativeOption={this.renderOptionLabel}
              renderSelectedValue={this.renderOptionLabel}
              valueAccessor={this.valueAccessorMultiSelect}
              value={this.state.vestEventsArray}
              onChange={this.onSelectVestEvent}
              isMulti={true}
            />
          </>
        }
      </>
    );
  }

  getIcon = (matches) => {
    if (matches.s) {
      return (
        <Col  alignItems="center">
          <IconChevronDown dataTestId="chevron_down_icon" aria-hidden={true}/>
        </Col>
      )
    }

    return (
      <>
        <Spacer flex={1}/>
          <Col padding={{top: 20}}>
            <IconArrowRight dataTestId="arrow_right_icon" aria-hidden={true}/>
          </Col>
        <Spacer flex={1}/>
      </>
    )
  }

  getTaxSelectComponents = (t, disabled) => {
    if (disabled) {
      return null;
    }

    const taxRatesRange = this.getTaxRatesRange();

    return (
      <WithBreakpoints>
        {({ matches }) => (
          <Flex flexDirection={matches.s ? "column" : "row"} gridGap="S400" alignItems={!matches.s ? "start" : null}>
            <Col>
              <InputWrapper
                dataTestId="ChangeTaxRateDialog_current_tax_rate_input"
                labelId="current-tax-rate-label"
                labelText={t('ChangeTaxRateDialog.CurrentTaxRate')}
                id="current-tax-rate"
              >
                {inputProps => (
                  <Select
                    dataTestId="ChangeTaxRateDialog_current_tax_rate_selection"
                    {...inputProps}
                    width={matches.s ? "100%" : 180}
                    options={[]}
                    noOptionsText={taxRatesRange}
                  />
                )}
              </InputWrapper>

            </Col>
            {this.getIcon(matches)}
            <Col>
              <InputWrapper
                dataTestId="ChangeTaxRateDialog_new_tax_rate_input"
                labelId="new-tax-rate-label"
                labelText={t('ChangeTaxRateDialog.NewTaxRate')}
                id="new-tax-rate"
                required
                error={this.state.newTaxRateReminderVisible}
                footer={this.state.newTaxRateReminderVisible ? t('ChangeTaxRateDialog.MustSelectTaxRate') : null}
              >
                {inputProps =>(
                  <Select
                    dataTestId="ChangeTaxRateDialog_new_tax_rate_selection"
                    {...inputProps}
                    ref={this.newTaxRateInputRef}
                    width={matches.s ? "100%" : 270}
                    renderOption={this.renderOptionLabel}
                    renderNativeOption={this.renderOptionLabel}
                    renderSelectedValue={this.renderOptionLabel}
                    valueAccessor={this.renderOptionLabel}
                    options={this.getTaxRatesOptions(t)}
                    onChange={this.onNewTaxRateChange}
                    listPositioningStrategy="fixed"
                  />
                )}
              </InputWrapper>
            </Col>
          </Flex>
        )}
      </WithBreakpoints>
    );
  }

  getButtonList = (t, disabledTaxOverride) => {
    var buttonList = [];
    buttonList.push(
      <Button onClick={this.props.onCloseDialog} variant={ButtonVariant.Secondary}>
        {t('ImpersonateUserDialog.CancelButton')}
      </Button>
    );
    if (!disabledTaxOverride) {
      buttonList.push(
        <LoadingButton
          onClick={this.taxRateAppliedHandler}
          variant={ButtonVariant.Primary}
          text={t('ChangeTaxRateDialog.ApplyTaxRate')}
          loading={this.state.loading}
        />
      );
    }
    return buttonList;
  }

  // Functions to render Objects in Stencil Select Components
  renderOptionLabel = (option) => {
    return option.label;
  }

  renderMultiOption = (option) => {
    return (
      <Row gridGap="S400">
        <Col gridGap="S100">
          <Text>{Moment(option.vest.vest_date).format('ll')}</Text>
          <Text fontWeight="light">{option.label}</Text>
        </Col>
        <Text fontWeight="light">
          {this.props.t("ChangeTaxRateDialog.VestEventCurrentRate") + ": " + formatPercentage(
            this.props.locale,
            (option.vest.fed_override_tax || option.award.fed_override_tax)
          )}
        </Text>
      </Row>
    );
  }

  valueAccessorMultiSelect = (option) => {
    return option.vest.id;
  }

  render() {
    const { t, employee } = this.props;
    const disabledTaxOverride = employeeService.hasRole(employee.roles, UserRoles.OVERRIDE_FED_TAX_DISABLE) ? true : false;

    return (
      <Flyout isOpen={this.props.visible} close={this.props.onCloseDialog}>
        <FlyoutContent
          dataTestId="ChangeTaxRateDialog_button"
          titleText={t('ChangeTaxRateDialog.Title')}
          closeButtonAltText="Close Button For Change Tax Rate Dialog"
          onCloseButtonClick={this.props.onCloseDialog}
          buttons={this.getButtonList(t, disabledTaxOverride)}
        >
          <Col gridGap="S400">
            <GenericDetailTitle
              title={t('USFedRateDialog.USFederalTaxRate')}
            />
            {!disabledTaxOverride &&
              <Text dataTestId="ChangeTaxRateDialog_USFedRateDialog" >{t('USFedRateDialog.IfYouNeed')}</Text>
            }
            {this.createPreclearanceText(t, employee)}
            <Hr/>
            {this.getAwardSelectComponents(t, disabledTaxOverride)}
            {this.getTaxSelectComponents(t, disabledTaxOverride)}
          </Col>
        </FlyoutContent>
      </Flyout>
    );
  }
}

const mapState = state => ({
  employee: state.employee,
  configuration: state.configuration,
  awards: employeeService.getAwardsForTaxElection(state.employee.awards),
  vestsByYear: employeeService.getVestsByYear(employeeService.getAwardsForTaxElection(state.employee.awards)),
  unvestedAwards: employeeService.getAwardsForTaxElection(state.employee.awards).filter((el) => !el.fully_vested),
  locale: state.employee.language
})

const mapDispatchToProps = dispatch => ({
  actions: {
    employee: bindActionCreators(employeeActions, dispatch)
  }
})

export default connect(mapState,mapDispatchToProps)(withTranslation('translationsV2')(ChangeTaxRateDialog))
